import React, { useContext } from "react";

import Nav from "./Nav";
import Copyright from "./Copyright";
import { LayoutContext } from "App/common/hoc/Layout";
import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";
import { config } from "config";
import { STATIC_URLS } from "consts";

function Sidebar(props) {
  const { lState, lMethods } = useContext(LayoutContext);

  return (
    <div className="main_sidebar">
      <div className="sidebar_bg_shadow" onClick={lMethods.toggleSidebar} />
      <div className="inner_sidebar">
        <div className="sidebar_menu">
          <Nav {...props} />
        </div>
        <div className="sidebar_bottom_section restore_btn">
          {props.route.pathname.includes("restore") && (
            <Tooltip
              {...(lState.sidebarCollapse
                ? TOOLTIPS.layout.download_iso_builder
                : {})}
            >
              <div className="restore_download_btn">
                <div
                  className="download_iso"
                  onClick={() =>
                    lMethods.openPopup("downloadRestoreISO", {
                      origin: props?.origin
                    })
                  }
                >
                  Download ISO Builder
                </div>
              </div>
            </Tooltip>
          )}

          <div className="sidebar_brand text-left">
            {config.APP_INSTANCE === "ibackup" ? null : (
              <ul>
                {/* <li>
                  <a
                    href={STATIC_URLS.features[config.APP_INSTANCE]}
                    target="_blank"
                  >
                    Features
                  </a>
                </li> */}
                <li>
                  <a
                    href={
                      STATIC_URLS.support[
                        props?.origin === "idrive"
                          ? "idrive"
                          : config.APP_INSTANCE
                      ]
                    }
                    target="_blank"
                  >
                    Support
                  </a>
                </li>
                <li>
                  <a
                    href={
                      STATIC_URLS.faqs[
                        props?.origin === "idrive"
                          ? "idrive"
                          : config.APP_INSTANCE
                      ]
                    }
                    target="_blank"
                  >
                    FAQs
                  </a>
                </li>
              </ul>
            )}
            <Copyright />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
